<div #customButton>
  <ng-content select="[menu-button]" />
</div>
@if (!customButton.hasChildNodes()) {
  <button
    pButton
    class="p-button p-button-primary p-button-outlined icon-only p-2"
    [ngClass]="buttonClass"
    [disabled]="isLoading"
    (click)="toggleMenu($event)">
    @if (!menu.overlayVisible) {
      <shared-icon icon="menu-dots" [height]="iconsHeight" [width]="iconsWidth" />
    }
    @if (menu.overlayVisible) {
      <shared-icon icon="cross" [height]="iconsHeight" [width]="iconsWidth" />
    }
  </button>
}
<p-popover #menu [dismissable]="true">
  <div class="menu-container">
    @for (item of menuItems; track item) {
      <div class="menu-item" (click)="item.command(null); menu.toggle($event)">
        @if (item.icon) {
          <shared-icon [icon]="item.icon" height="1rem" width="1rem" />
        }
        {{ item.label }}
      </div>
    }
  </div>
</p-popover>
